import { registerPlugin } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';

export interface HmsPushPlugin {
  getPushProvider(): Promise<{ provider: 'FCM' | 'HMS' }>;
  register(): Promise<{ token: string | null }>;
  addListener(eventName: 'tokenRefresh', listenerFunc: (event: { token: string }) => void): Promise<PluginListenerHandle>;
}

export const HmsPush = registerPlugin<HmsPushPlugin>('HmsPush');
